export const baseURLs = () => {
  // return "http://localhost:7002"
  return "https://partnerapi.leadchainsystems.com"
  // return "https://testapi.leadchainsystems.com"
}
